import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FAQHero from './components/FAQHero';
import FAQAccordion from './components/FAQAccordion';

export default function FAQPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://trackverse.com';

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://track-verse.com';
    document.title = 'FAQ — Questions Fréquentes sur la Logistique & Suivi Colis | TrackVerse';
    document.documentElement.lang = 'fr';

    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute('content', content);
    };

    setMeta('description', 'Trouvez des réponses à vos questions sur les services TrackVerse : méthodes d\'expédition, suivi colis, douanes, assurance, tarifs et délais de livraison internationale.');
    setMeta('keywords', 'FAQ logistique, questions expédition, aide suivi colis, dédouanement, tarifs fret, délais livraison, TrackVerse aide');

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); (canonical as HTMLLinkElement).rel = 'canonical'; document.head.appendChild(canonical); }
    (canonical as HTMLLinkElement).href = `${siteUrl}/faq`;

    setMeta('og:title', 'FAQ TrackVerse — Questions Fréquentes Logistique & Suivi Colis', true);
    setMeta('og:description', 'Réponses aux questions fréquentes sur nos services : suivi colis, expédition, douanes, assurance, tarifs.', true);
    setMeta('og:url', `${siteUrl}/faq`, true);
    setMeta('og:type', 'website', true);
    setMeta('og:image', `${siteUrl}/og-image.jpg`, true);
    setMeta('twitter:title', 'FAQ TrackVerse — Questions Fréquentes Logistique');
    setMeta('twitter:description', 'Réponses sur nos services de suivi colis, expédition, douanes et tarifs.');
    setMeta('twitter:image', `${siteUrl}/og-image.jpg`);

    const faqPageSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Accueil", "item": `${siteUrl}/` },
          { "@type": "ListItem", "position": 2, "name": "FAQ", "item": `${siteUrl}/faq` }
        ]
      },
      "mainEntity": [
        { "@type": "Question", "name": "Quelles méthodes d'expédition proposez-vous ?", "acceptedAnswer": { "@type": "Answer", "text": "Nous proposons le fret aérien express (1-3 jours), le fret aérien standard (3-7 jours), le fret maritime (15-45 jours) et le transport terrestre pour les livraisons régionales." } },
        { "@type": "Question", "name": "Combien de temps prend l'expédition internationale ?", "acceptedAnswer": { "@type": "Answer", "text": "Les délais varient selon la destination et le mode : fret aérien express 1-3 jours, standard 3-7 jours, fret maritime 15-45 jours. Le dédouanement peut ajouter 1-3 jours supplémentaires." } },
        { "@type": "Question", "name": "Livrez-vous dans tous les pays ?", "acceptedAnswer": { "@type": "Answer", "text": "Nous expédions dans plus de 180 pays. Notre réseau couvre les grandes villes et les zones éloignées. Contactez-nous pour confirmer la disponibilité vers votre destination." } },
        { "@type": "Question", "name": "Comment suivre mon envoi ?", "acceptedAnswer": { "@type": "Answer", "text": "Utilisez votre numéro de suivi unique sur notre page de tracking pour des mises à jour en temps réel incluant la localisation, l'historique et la date de livraison estimée." } },
        { "@type": "Question", "name": "Comment le coût d'expédition est-il calculé ?", "acceptedAnswer": { "@type": "Answer", "text": "Le coût est basé sur le poids réel ou volumétrique (longueur × largeur × hauteur ÷ 5000), l'origine, la destination, le mode d'expédition et les services additionnels. Obtenez un devis instantané en ligne." } }
      ]
    };

    let script = document.querySelector('script[data-schema="faq-page"]');
    if (!script) { script = document.createElement('script'); script.setAttribute('type', 'application/ld+json'); script.setAttribute('data-schema', 'faq-page'); document.head.appendChild(script); }
    script.textContent = JSON.stringify(faqPageSchema);

    return () => { const s = document.querySelector('script[data-schema="faq-page"]'); if (s) s.remove(); };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <FAQHero />
      <FAQAccordion />
      <Footer />
    </div>
  );
}
